import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["type"]
const _hoisted_2 = {
  key: 0,
  class: "ui-btn__loader"
}
const _hoisted_3 = { class: "ui-btn__in" }
const _hoisted_4 = {
  key: 0,
  class: "ui-btn__before"
}
const _hoisted_5 = { class: "ui-btn__content" }
const _hoisted_6 = {
  key: 1,
  class: "ui-btn__after"
}

import { PropType } from "vue";

import UiLoader from "./UiLoader.vue";

type ButtonType = "button" | "reset" | "submit";
type ButtonSize = "sm" | "md" | "lg";
type ButtonVariant =
  | "primary"
  | "secondary"
  | "tertiary"
  | "commerce"
  | "alert";


export default /*#__PURE__*/_defineComponent({
  __name: 'UiBtn',
  props: {
  type: { type: String as PropType<ButtonType>, default: "button" },
  variant: { type: String as PropType<ButtonVariant>, default: "primary" },
  size: { type: String as PropType<ButtonSize>, default: "md" },
  loading: Boolean,
  stretched: Boolean,
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    type: __props.type,
    class: _normalizeClass(["ui-btn", {
      'ui-btn--stretched': __props.stretched,
      [`ui-btn--${__props.size}`]: __props.size,
      [`ui-btn--${__props.variant}`]: __props.variant,
    }])
  }, [
    (__props.loading)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
          (__props.loading)
            ? (_openBlock(), _createBlock(UiLoader, { key: 0 }))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("span", _hoisted_3, [
      (_ctx.$slots.before)
        ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
            _renderSlot(_ctx.$slots, "before")
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("span", _hoisted_5, [
        _renderSlot(_ctx.$slots, "default")
      ]),
      (_ctx.$slots.after)
        ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
            _renderSlot(_ctx.$slots, "after")
          ]))
        : _createCommentVNode("", true)
    ])
  ], 10, _hoisted_1))
}
}

})